import { Spacings } from '@styles/index';
import { GroupObjectType } from 'types/groups/index';

// eslint-disable-next-line import/prefer-default-export
export const scoreboardColorMapping = {
  1: {
    color: 'var(--color-i-orange-2)',
    positionColor: 'var(--color-i-white)',
    positionBgColor: 'var(--color-i-orange-2)'
  },
  2: {
    color: 'var(--color-i-silver)',
    positionColor: 'var(--color-i-silver)',
    positionBgColor: 'var(--color-i-light-silver)'
  },
  3: {
    color: 'var(--color-i-brown-1)',
    positionColor: 'var(--color-i-white)',
    positionBgColor: 'var(--color-i-brown-1)'
  },
  me: {
    color: 'var(--color-text-primary)',
    positionColor: 'var(--color-base-1)',
    positionBgColor: 'var(--color-text-primary)'
  },
  default: {
    color: 'var(--color-text-secondary)',
    positionColor: 'var(--color-text-secondary)',
    positionBgColor: 'var(--color-base-light-0)'
  }
};

export const leaderboardRankSize = [
  {
    height: '14px',
    width: Spacings.SPACING_10B
  },
  {
    height: Spacings.SPACING_4B,
    width: Spacings.SPACING_12B
  },
  {
    height: '13px',
    width: '37px'
  }
];

export const weekDaysArray = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];

export const groupsDrawerTypes = {
  DEFAULT: 'DEFAULT',
  CHANGE_GROUP: 'CHANGE_GROUP',
  LEAVE_GROUP: 'LEAVE_GROUP',
  JOIN_GROUP: 'JOIN_GROUP',
  LEADERBOARD_CARD: 'LEADERBOARD_CARD'
};

export const groupPerks = [
  {
    icon: 'groups/chart.png',
    label: 'Weekly competitions'
  },
  {
    icon: 'groups/book.png',
    label: 'See what everyone is learning'
  },
  {
    icon: 'groups/star.png',
    label: 'Celebrate milestones'
  }
];

export const ActivityObjectTypeInfo = {
  [GroupObjectType.PRACTICING]: {
    pastPrefix: 'Last practiced ',
    presentPrefix: 'Practicing ',
    icon: 'groups/practice.svg',
    activity: 'Practising',
    color: 'var(--color-i-practice)'
  },
  [GroupObjectType.IN_CLASS]: {
    pastPrefix: 'Last watched ',
    presentPrefix: 'Watching ',
    icon: 'groups/play.svg',
    activity: 'Watching a class',
    color: 'var(--color-i-class)'
  },
  [GroupObjectType.COMBAT]: {
    pastPrefix: 'Last attempted',
    presentPrefix: 'Attempting',
    icon: 'groups/combat.svg',
    activity: 'Attempting combat',
    color: 'var(--color-i-combat-blue)'
  },
  [GroupObjectType.TAKING_A_TEST]: {
    pastPrefix: 'Last attempted',
    presentPrefix: 'Attempting',
    icon: 'groups/test.svg',
    activity: 'Taking a test',
    color: 'var(--color-i-test-pink)'
  },
  [GroupObjectType.TAKING_A_QUIZ]: {
    pastPrefix: 'Last attempted',
    presentPrefix: 'Attempting',
    icon: 'groups/practice.svg',
    activity: 'Attempting quiz',
    color: 'var(--color-i-practice)'
  },
  [GroupObjectType.READING_NOTES]: {
    pastPrefix: 'Last read ',
    presentPrefix: 'Reading ',
    icon: 'groups/read.svg',
    activity: 'Reading Notes',
    color: 'var(--color-i-notes)'
  }
};
